import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { hasVisibleContent } from '@atlaskit/editor-common/utils';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';

export const documentContentStatePluginKey: PluginKey = new PluginKey('ai-document-content-state');

export type DocumentContentState = {
	consumerEmptyStateOverride?: boolean;
	hasVisibleContent: boolean;
};

export const SET_CONSUMER_EMPTY_STATE_OVERRIDE = 'set-consumer-empty-state-override';

export const createDocumentContentStatePlugin = (): SafePlugin<DocumentContentState> => {
	const isSmartRepliesEnabled = expValEqualsNoExposure('jira-smart-replies-v2', 'isEnabled', true);
	return new SafePlugin<DocumentContentState>({
		key: documentContentStatePluginKey,
		state: {
			init(_, state) {
				return {
					hasVisibleContent: hasVisibleContent(state.doc),
					consumerEmptyStateOverride: undefined,
				};
			},
			apply(tr, pluginState, _, newState) {
				if (isSmartRepliesEnabled) {
					let next = pluginState;
					const meta = tr.getMeta(documentContentStatePluginKey);
					if (
						meta?.type === SET_CONSUMER_EMPTY_STATE_OVERRIDE &&
						meta?.value !== next.consumerEmptyStateOverride
					) {
						next = { ...next, consumerEmptyStateOverride: meta.value };
					}

					if (tr.docChanged) {
						const newHasVisibleContent = hasVisibleContent(newState.doc);
						if (next.hasVisibleContent !== newHasVisibleContent) {
							next = { ...next, hasVisibleContent: newHasVisibleContent };
						}
					}
					return next;
				}

				if (!tr.docChanged) {
					return pluginState;
				}

				const newHasVisibleContent = hasVisibleContent(newState.doc);
				if (pluginState.hasVisibleContent !== newHasVisibleContent) {
					return { hasVisibleContent: newHasVisibleContent };
				}

				return pluginState;
			},
		},
	});
};
